export default __webpack_public_path__ + "02ee467414ed0ea8c96e7c66bab6e2ab.png";